module.exports = __webpack_public_path__ + "media/images/clearcash-win-0fa69b60ea48be6d68258ccc2bb6e1bf.png";